export default "__VITE_ASSET__BwfH2fHP__"